import { useEffect, useRef, useState } from "react";
import Web3Modal from "web3modal";
import {BigNumber, Contract, providers, utils} from "ethers";

import bitcoin from "./images/bitcoin.png";
import abi from "./utils/abi.json";
import './App.css';

function App() {
  const zero = BigNumber.from(0);
  const contractABI = abi.abi;
  const contractAddress = "0x9fdB8291e8F9E16d9C597764c7a48ba68F435B8b";

  const [amount, setAmount] = useState()
  const [tokenMinted, setTokenMinted] = useState(zero);
  const [walletConnected, setWalletConnected] = useState(false);
  const [btnStatus, setBtnStatus] = useState("Mint");
  const [txHash, setTxHash] = useState("");

  const web3ModalRef = useRef();

  async function getProviderOrSigner(needSigner= false){
    try{
      const provider = await web3ModalRef.current.connect();
      const web3Provider = new providers.Web3Provider(provider);
      const {chainId} = await web3Provider.getNetwork();
      if(chainId !== 4){
        window.alert("change your network to rinkeby.");
        throw new Error("change network to rinkeby.")
      }
      if(needSigner)
        return web3Provider.getSigner();

      return web3Provider;
    }
    catch(err){
      console.log(err);
    }
  }

  async function mintToken(amount){
    try{
      const signer = await getProviderOrSigner(true);
      
      const tokenContract = new Contract(contractAddress, contractABI, signer);
      
      // Each token is of `0.0001 ether`. The value we need to send is `0.001 * amount`
      const value = 0.0001 * amount;

      //checking if user have sufficient ETH to complete the transcation.
      if( utils.formatEther(BigNumber.from(await signer.getBalance()).toString()) < value){
        window.alert("You have Insufficent ETH.");
        throw new Error("Insufficent ETH to complete the transcation.")
      }

      const tx = await tokenContract.mint(amount, {
        // value signifies the cost of one crypto dev token which is "0.0001" eth.
        // We are parsing `0.0001` string to ether using the utils library from ethers.js
        value: utils.parseEther(value.toString()),
      })
      setTxHash(tx.hash.toString());
      setBtnStatus("Minting...")
      await tx.wait();
      setBtnStatus("Mint");
      window.alert("Successfully Minted Hitcoin.");
      setAmount(null);
      await getTokenMinted();
    }
    catch(err){
      console.log(err);
    }
  }

  async function getTokenMinted() {
    try{
      const provider = await getProviderOrSigner();  
      const tokenContract = new Contract(contractAddress, contractABI, provider);
      
      // Get all the tokens that have been minted till now and set that to tokenMited state
      const _tokensMinted = await tokenContract.totalSupply();
      setTokenMinted(BigNumber.from(_tokensMinted));
    }
    catch(err){
      console.log(err);
    }
  }
  
  async function connectWallet() {
    try{
      if( await getProviderOrSigner() )
      {
        getTokenMinted();
        setWalletConnected(true);
      }
    }
    catch(err){
      console.log(err);
    }

  }


  useEffect( () => {
    if(!walletConnected){
      web3ModalRef.current = new Web3Modal({
        network: "rinkeby",
        providerOptions: {},
        disableInjectedProvider: false
      })
    }

  }, [walletConnected])

  return (
    <div>
      <div className="introBox">
        <h1>HITCOIN</h1>
        <p>The coin which will never beat Bitcoin.</p>
      </div>

      <div className="bitcoinBox">
        <img className="bitcoin" src={bitcoin} alt="Coin" />
        <p>we &hearts; Bitcoin</p>
      </div>

      <div className="main">
        <p style={{fontSize: "1.5rem"}}>{utils.formatEther(tokenMinted)} / 100 Trillion</p>
        <div>
          <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} id="amount" placeholder="amount"/>
        </div>
        {amount && <p style={{color: "#B0A8B9"}}>you have to pay {amount * 0.0001} ether for {amount} HTC </p>}
        {walletConnected && <button disabled={!amount > 0} onClick={() => mintToken(amount)}>{btnStatus}</button>}
        {!walletConnected && <button onClick={connectWallet}>Connect Wallet</button>}
        {txHash && <a target="_blank" href={"https://rinkeby.etherscan.io/tx/" + txHash} >view on etherscan</a>}
      </div>
  
      <div className="footer">
        <p>Made with &hearts; by <a target="_blank" href="https://github.com/Ramanbaral">Raman</a></p>
      </div>
    </div>
  );
}

export default App;
